import type { ITableHeader } from "libs/design-system/src/types/table/table_header";
import { SkeletonBase } from "../../SkeletonLoader/SkeletonBase";
import { Button } from "../../Button";
import styles from "./table-header.module.scss";

export const TableHeader = ({
  isLoading,
  title,
  actionBtns
}: ITableHeader) => {
  return (
    <div className={styles["table-header"]}>

      <div className={styles["table-header__title"]}>
        {title}
      </div>

      {
        !!actionBtns?.length &&
        <div className={styles["table-header__action-btns"]}>
          {
            isLoading ?
              <SkeletonBase height="2.5rem" />
              :
              actionBtns.map((btn, i) =>
                <Button
                  key={i}
                  {...btn}
                  size="md"
                />
              )
          }
        </div>
      }
    </div>
  )
}
